import Swiper from 'swiper';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';

export default {
    init() {
        const blocks = document.querySelectorAll('.wp-block-flip-blocks-event-slider');

        if (!blocks.length) return;

        const isMobile = window.innerWidth < 768;

        blocks.forEach((block) => {
            const slider = block.querySelector('.events-slider');
            if (!slider) return;

            const autoplay = block.dataset.autoplay === 'true';
            const speed = parseInt(block.dataset.sliderSpeed) || 3000;
            
            const showNav = block.dataset.showNavigation === 'true';

            const navWrapper = isMobile
            ? block.querySelector('.events-slider-block__nav--mobile')
            : block.querySelector('.events-slider-block__nav');

            const nextBtn = navWrapper?.querySelector('.swiper-button-next');
            const prevBtn = navWrapper?.querySelector('.swiper-button-prev');

            const slidesCount = slider.querySelectorAll('.swiper-slide').length;

            new Swiper(slider, {
                modules: [Navigation, Autoplay, Pagination],

                slidesPerView: 4,
                spaceBetween: 40,

                breakpoints: {
                    0: { slidesPerView: 1, spaceBetween: 16 },
                    640: { slidesPerView: 2, spaceBetween: 20 },
                    1024: { slidesPerView: 3, spaceBetween: 24 },
                    1280: { slidesPerView: 4, spaceBetween: 40 },
                },

                navigation: (showNav)
                    ? {
                        nextEl: nextBtn,
                        prevEl: prevBtn,
                    }
                    : false,

                pagination: {
                    el: block.querySelector('.swiper-pagination'),
                    clickable: true,
                },

                autoplay: autoplay
                    ? {
                        delay: speed,
                        disableOnInteraction: false,
                    }
                    : false,

                loop: false
            });
        });
    }
};